import { API } from "./utils"

export const auth = {
  getUser: () => API.get("/auth/user/"),
  token: (email, password) => API.post("/auth/token/", { email, password }),
  setLanguage: language => API.post("/auth/language/", { language }),
  resetPassword: email => API.post("/auth/reset-password/", { email }),
}
